import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { getBidsService } from './bids-home-service';
import { useDispatch, useSelector } from 'react-redux';
import { db } from '../../../firebase';
import { showErrorSnackbar } from '../../shared/snackbar/snackbar-slice';
import { useNavigate } from 'react-router-dom';
import { setCurrentItem } from './bids-item/bids-item-slice';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '80%',
    margin: 'auto',
    marginTop: 50,
    textAlign: 'left',
  },
  image: {
    width: '100%',
    maxWidth: 400,
    height: 'auto',
    margin: '20px 0',
  },
  button: {
    margin: '20px 0',
    background: '#111111',
    color: '#fbbbd3',
    '&:hover': {
      backgroundColor: '#fbbbd3',
      color: '#111111',
    },
  },
  text: {
    color: "#111111",
  },
  title: {
    background:"#111111",
  },
}));

const BidsHome = () => {
  const classes = useStyles();
  const bidsCollection = useSelector((state) => state.bidsHomeSlice.rows);
  const isLoading = useSelector((state) => state.bidsHomeSlice.isLoading);
  const [joinModalOpen, setJoinModalOpen] = useState(false);
  const [onGoing, setOnGoing] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // get data
  useEffect(() => {
    const fetchData = async () => {
        try {
            await getBidsService(dispatch, db, "bids");
        } catch(e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
            console.error("BidsHome fetchData error: ", e);
        }
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
        try {
            if (bidsCollection.length) {
                const onGoingBid = bidsCollection.filter((bid) => bid.status === "On Going");
                if (onGoingBid.length) {
                    setOnGoing(onGoingBid[0]);
                }
            }
        } catch(e) {
            dispatch(showErrorSnackbar("Something went wrong while trying to fetch."));
            console.error("BidsHome fetchData error: ", e);
        }
    };
    fetchData();
  }, [dispatch, bidsCollection]);

  console.log("onGoing: ", onGoing);

  const handleCountMeIn = () => {
    // Add your logic for joining the auction
    console.log('Count me in clicked!');
  };

  const handleJoin = () => {
    setJoinModalOpen(true);
  };

  const handleCloseJoinModal = () => {
    setJoinModalOpen(false);
  };

  const handleOKModal = () => {
    handleCloseJoinModal();
    // dispatch(setCurrentItem(onGoing));
    navigate(`/app/bids/${onGoing.id}`);
  }

  return (
    <Card className={classes.root}>
      <CardContent>
        <Typography variant="h5" component="div" className={classes.text}>
          Hello, Ladies and gents! This is Peridot, your host for this first ever mini auction.
          And, I welcome you to Peridot's Auction House!
        </Typography>
        <br/>
        <Typography variant="body1" color="textSecondary">
            For our first mini auction, let me introduce to you our lineup:
        </Typography>

        <img
          src="https://placekitten.com/400/200" // Replace with your image source
          alt="Auction Lineup"
          className={classes.image}
        />

        <Typography variant="body1" color="textSecondary">
          To join, click <Button variant="contained" className={classes.button} onClick={handleCountMeIn}>Count Me In</Button>.
        </Typography>
        <br/>
        <Typography variant="body1" color="textSecondary">
          By joining, you will have access to our auction house. You can bid and see the current
          item getting auctioned off, the current bid, the latest bidder, and the successful bidder!
        </Typography>
        <br/>
        <Typography variant="body1" color="textSecondary">
          But, wait. There is more!
        </Typography>
        <br/>
        <Typography variant="body1" color="textSecondary">
          Once you are joined, you will receive an invitation letter with a token via email.
          You can use your token to win a raffle at the end of the auction!
        </Typography>
        <br/>
        <Typography variant="body1" color="textSecondary">
          Best of luck to you!
        </Typography>
        <br/>
        <Typography variant="body1" color="textSecondary">
          Did you receive your invitation? Click{' '}
          <Button variant="contained" className={classes.button} onClick={handleJoin}>
            Join
          </Button>{' '}
          to get started.
        </Typography>
      </CardContent>

      {/* Join Modal */}
      <Dialog open={joinModalOpen} onClose={handleCloseJoinModal}>
        <DialogTitle className={classes.title}>Join Auction</DialogTitle>
        <DialogContent>
          {/* Add content for the Join Auction modal */}
          <Typography variant="body1" className={classes.text}>
            This is the content for the Join Auction modal.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseJoinModal} color="primary">
            Close
          </Button>
          {/* Add additional actions if needed */}
        </DialogActions>
        <DialogActions>
          <Button
            variant="contained"
            className={classes.button}
            onClick={handleOKModal}
            // disabled={isLoading}
        >
            Join
          </Button>
          {/* Add additional actions if needed */}
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default BidsHome;